import React from 'react';
import { Fees } from '../../../../api/api-fees';
import * as types from '../constants/action-types';
import { get } from 'lodash';

export function createBillingRequest (isPosting) {
  return {
    type: types.BILLING_CREATE_REQUEST,
    isPosting
  };
}

export function createBillingSuccess (data) {
  return {
    type: types.BILLING_CREATE_SUCCESS,
    data
  };
}

export function createBillingFailure (postError) {
  return {
    type: types.BILLING_CREATE_FAILURE,
    postError
  };
}

export function createVatRequest (isPosting) {
  return {
    type: types.VAT_CREATE_REQUEST,
    isPosting
  };
}

export function createVatSuccess (data) {
  return {
    type: types.VAT_CREATE_SUCCESS,
    data
  };
}

export function createVatFailure (postError) {
  return {
    type: types.VAT_CREATE_FAILURE,
    postError
  };
}

export function fetchBillingRequest (isFetching) {
  return {
    type: types.BILLING_FETCH_REQUEST,
    isFetching
  };
}

export function fetchBillingSuccess (data) {
  return {
    type: types.BILLING_FETCH_SUCCESS,
    data
  };
}

export function fetchBillingFailure (fetchError) {
  return {
    type: types.BILLING_FETCH_FAILURE,
    fetchError
  };
}

export function fetchAllFeeProfilesRequest (isFetching) {
  return {
    type: types.FEE_PROFILES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchAllFeeProfilesSuccess (data) {
  return {
    type: types.FEE_PROFILES_FETCH_SUCCESS,
    data
  };
}

export function fetchAllFeeProfilesFailure (fetchError) {
  return {
    type: types.FEE_PROFILES_FETCH_FAILURE,
    fetchError
  };
}

export function fetchAddressByIdRequest (isFetching) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_REQUEST,
    isFetching
  };
}

export function fetchAddressByIdSuccess (data) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_SUCCESS,
    data
  };
}

export function fetchAddressByIdFailure (fetchError) {
  return {
    type: types.FETCH_ADDRESS_BY_ID_FAILURE,
    fetchError
  };
}

export function createBillingAddress (accessToken, ssoId, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createBillingRequest(true));

      Fees.createBillingAddress(accessToken, ssoId, payload, response => {
        if (200 === response.statusCode) {
          dispatch(createBillingSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error creating billing address';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(createBillingFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchBillingAddress (accessToken, ssoId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchBillingRequest(true));

      Fees.fetchAddress(accessToken, ssoId, 'billing', response => {
        if (200 === response.statusCode) {
          dispatch(fetchBillingSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error fetching billing address';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchBillingFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchAllFeeProfiles (accessToken, ssoId) {
  // fetches all ACTIVE user's BILLING and VAT addresses
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchAllFeeProfilesRequest(true));

      Fees.fetchAllFeeProfiles(accessToken, ssoId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchAllFeeProfilesSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error fetching fee profiles';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchAllFeeProfilesFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchAddressById (accessToken, feeProfileId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchAddressByIdRequest(true));

      Fees.fetchAddressById(accessToken, feeProfileId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchAddressByIdSuccess(response));

          return resolve(response);
        }

        const defaultErrMsg = 'Error fetching fee profile';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchAddressByIdFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}
